var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAcc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t\t.st0{display:none;}\r\n\t\t.st1{display:inline;}\r\n\t\t.st2{fill:#010101;}\r\n\t\t.st3{fill:#FFFFFF;}\r\n\t\t.st4{display:inline;fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t\t.st5{font-family:'MyriadPro-Bold';}\r\n\t\t.st6{font-size:18.8696px;}\r\n\t\t.st7{fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t\t.st8{enable-background:new;}\r\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    fill: "currentColor",
    cx: 23.9,
    cy: 24,
    r: 21.6
  }), /*#__PURE__*/React.createElement("g", {
    className: "st8",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2,29.6h-2.7l-1.1-2.8H9.5l-1,2.8H5.9l4.7-12.2h2.6L18.2,29.6z M13.6,24.8l-1.7-4.5l-1.6,4.5H13.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2,25.2l2.4,0.8c-0.4,1.3-1,2.3-1.8,3s-1.9,1-3.2,1c-1.6,0-2.9-0.6-4-1.7c-1-1.1-1.6-2.6-1.6-4.5c0-2,0.5-3.6,1.6-4.7 c1-1.1,2.4-1.7,4.1-1.7c1.5,0,2.7,0.4,3.6,1.3c0.6,0.5,1,1.3,1.2,2.2l-2.4,0.6c-0.1-0.6-0.4-1.1-0.9-1.5s-1-0.5-1.7-0.5 c-0.9,0-1.6,0.3-2.2,1c-0.6,0.6-0.8,1.7-0.8,3.1c0,1.5,0.3,2.6,0.8,3.3s1.3,1,2.2,1c0.7,0,1.2-0.2,1.7-0.6 C26.7,26.7,27,26.1,27.2,25.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5,25.2l2.4,0.8c-0.4,1.3-1,2.3-1.8,3s-1.9,1-3.2,1c-1.6,0-2.9-0.6-4-1.7c-1-1.1-1.6-2.6-1.6-4.5c0-2,0.5-3.6,1.6-4.7 c1-1.1,2.4-1.7,4.1-1.7c1.5,0,2.7,0.4,3.6,1.3c0.6,0.5,1,1.3,1.2,2.2l-2.4,0.6c-0.1-0.6-0.4-1.1-0.9-1.5s-1-0.5-1.7-0.5 c-0.9,0-1.6,0.3-2.2,1c-0.5,0.5-0.8,1.5-0.8,3s0.3,2.6,0.8,3.3s1.3,1,2.2,1c0.7,0,1.2-0.2,1.7-0.6C39,26.7,39.3,26.1,39.5,25.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcc);
export default __webpack_public_path__ + "static/media/acc.4c2cef9cbfcc297e12075f8687f56010.svg";
export { ForwardRef as ReactComponent };